import { computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { localizable } from 'components/Localization';
import Loading from 'components/LoadingOverlay';
import { Error, Success } from 'components/MessageOverlay';

@inject('app', 'user', 'sale')
@localizable
@observer
class Whitelisting extends Component {
  @observable error = undefined;
  @observable ok = undefined;
  @observable executing = true;

  @computed get hasResponse() {
    return this.ok !== undefined;
  }

  async componentDidMount() {
    const { sale, match, t } = this.props;
    const { action, user: userId, sale: saleId } = match.params;

    switch (action) {
      case 'accept':
        this.ok = await sale.whitelisting.accept({ userId, saleId });
        break;
      case 'block':
        this.ok = await sale.whitelisting.block({ userId, saleId });
        break;
      default:
        this.error = t('whitelisting_unknown_action');
        break;
    }

    if (!this.ok) {
      this.error = t('whitelisting_error');
    }
    this.executing = false;
  }

  handleResponse = () => {
    const { match, history } = this.props;
    const { sale } = match.params;
    history.push(`/dashboard/${sale}`);
  };

  render() {
    const { t } = this.props;
    return this.executing ? (
      <Loading fullscreen={true} />
    ) : this.ok ? (
      <Success message={t('whitelisting_done')} onClick={this.handleResponse} />
    ) : (
      <Error message={this.error} onClick={this.handleResponse} />
    );
  }
}

export default Whitelisting;



// WEBPACK FOOTER //
// ./src/app/containers/Whitelisting/index.jsx